import React, { useEffect, useState } from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/background-img.png";
import "../../assets/styles/contact.css";
import ContactAddress from "../../assets/images/contact-img.15a914b7.png";
import { axiosInstance } from "../config";
import { notification } from "antd";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";

const Index = () => {
  useEffect(() => window.scrollTo(0, 0), [])
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [service, setService] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [isLoading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", mobile);
    formData.append("details", message);
    formData.append("service", service);
    formData.append("company_name", companyName);
    try {
      const res = await axiosInstance.post("contact", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      if (res.data.message == "Message Succesfully sent...") {
        notification.open({
          message: "Message Received Successfully ",
          description: (
            <div style={{ color: "#000", zIndex: 999 }}>
              Your message has been sent! 🎉 Thank you for reaching out to us.
              We’re excited to connect and will get back to you shortly. Stay
              tuned!
            </div>
          ),
          showProgress: true,
          className: "custom-notification",
        });
        setName("");
        setEmail("");
        setMessage("");
        setMobile("");
        setService("");
        setCompanyName("");
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div>
      <Helmet>
        <title>Contact Us - Elementeers Nucleons</title>
      </Helmet>
      {/* {isLoading && <Loader />} */}
      <Navbar inner={true} />
      <BannerSection
        Banner={ContactBanner}
        title={"Contact us"}
        subtitle={"Let success motivate you."}
      />

      <div className="">
        <div className="contact-info-area ptb-80 bg-f9f6f6">
          <div className="container">
            <div className="row justify-content-center">
              <div
                className={`col-lg-4 col-md-6 col-sm-6 contact-details service-animate ${inView1 ? "visible" : ""
                  }`}
                ref={ref1}
              >
                <div className="contact-info-box">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </div>
                  <h3>Mail Here</h3>
                  <p>
                    <a href="mailto:info@elementeers.com" className="mr-1">
                      info@elementeers.com
                    </a> <br />
                    <a href="mailto:services@elementeers.com" className="ml-1">
                      services@elementeers.com
                    </a>
                  </p>
                </div>
              </div>
              <div
                className={`col-lg-4 col-md-6 col-sm-6 contact-details service-animate ${inView2 ? "visible" : ""
                  }`}
                ref={ref2}
              >
                <div className="contact-info-box">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                  </div>
                  <h3>Visit Here</h3>
                  <p>E-201, Svayam Sapphire, Opp. Madhuban Resort, Vithal Udyognagar, GIDC, Anand-388001</p>
                </div>
              </div>
              <div
                className={`col-lg-4 col-md-6 col-sm-6 contact-details phone-num service-animate ${inView3 ? "visible" : ""
                  }`}
                ref={ref3}
              >
                <div className="contact-info-box">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </div>
                  <h3>Call Here</h3>
                  <p>
                    <a href="tel:+91-8401206515" className="">+91 84012 06515</a> <br />
                    <a href="tel:+91-9512085180" className="">+91 95120 85180</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-area ptb-80">
          <div className="container">
            <div className="section-title">
              <h2>Get In Touch With Us</h2>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3685.00791294818!2d72.93757467499049!3d22.541376334114652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e4dd1756a039d%3A0x21438f1d96df6797!2sSvayam%20Symphony!5e0!3m2!1sen!2sin!4v1746944843368!5m2!1sen!2sin"
                  width="97%"
                  height="400"
                  loading="lazy"
                ></iframe>
                </div>
              <div className="col-lg-6 col-md-12  form-enquiry">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          className="form-control"
                          aria-label="Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="company_name"
                          placeholder="Company Name"
                          className="form-control"
                          required=""
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="email"
                          placeholder="Email Address"
                          className="form-control"
                          aria-label="Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="number"
                          id="phone"
                          placeholder="Phone Number"
                          className="form-control"
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <textarea
                          name="text"
                          cols="30"
                          rows="5"
                          placeholder="Share your Requirement"
                          className="form-control"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-lg-12 col-sm-12">
                      <button type="submit" className="btn btn-primary submit-btn">
                        Send Message
                        {isLoading && (
                          <span
                            className="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
